import { takeLatest, put, delay } from 'redux-saga/effects';
import * as TYPES from '../actions/types';
import { getClientTreatmentPlanSign, loaderAction, saveCarePlan, saveCarePlanReSignNotifications, saveClientTreatmentPlanSign } from '../actions';
import { GenericResponseModel } from '../../dataModel/authModels';
import { CarePlan } from '../../services/care-plan';
import { GET_CLIENT_TREATMENT_PLAN_SIGN } from '../actions/types';

export function* getCarePlanSaga() {
  try {
    yield takeLatest(TYPES.GET_CARE_PLAN, getCarePlanWorker);
  } catch (err) {
  }
}

function* getCarePlanWorker(param: any) {
  try {
    yield put(loaderAction(true));
    const response: GenericResponseModel = yield CarePlan.getCP(param['payload']);
    if (param['payload']) {
      yield put(saveCarePlan([response.resultData]));
    } else {
      yield put(saveCarePlan(response.resultData));
    }
    yield put(loaderAction(false));
  } catch (e) {
  }
}

export function* getClientTreatmentPlanSignSaga() {
  yield takeLatest(GET_CLIENT_TREATMENT_PLAN_SIGN, clientTreatmentPlanSignAction);
}


function* clientTreatmentPlanSignAction(param: any) {
  try {
    yield put(loaderAction(true));
    const response: GenericResponseModel = yield CarePlan.getTpSign(param['payload']);
    if (response.resultData) {
      yield put(saveClientTreatmentPlanSign([response.resultData]));
    }
    yield put(loaderAction(false))
  } catch (e) {
  }
}


export function* ApplyClientSignatureSaga() {
  try {
    yield takeLatest(TYPES.APPLY_CLIENT_SIGNATURE, ApplyClientSignatureSagaActions);
  } catch (err) {
    console.error('ApplyClientSignatureSaga error:', err);
  }
}
function* ApplyClientSignatureSagaActions(param: any) {
  try {
    yield put(loaderAction(true));
    const response: GenericResponseModel = yield CarePlan.applySignature(param['payload'].payload);
    yield put(loaderAction(false));
    if (response.resultData) {
      yield put(getClientTreatmentPlanSign(param['payload'].id));
    }
  } catch (e) {
  }
}

export function* getCarePlanReSignNotificationSaga() {
  try {
    yield takeLatest(TYPES.GET_CP_RESIGN_NOTIFICATION, getCarePlanReSignNotificationWorker);
  } catch (err) {
  }
}

function* getCarePlanReSignNotificationWorker() {
  try {
    yield put(loaderAction(true));
    const response: GenericResponseModel = yield CarePlan.getCarePlanReSignNotifications();
    yield put(saveCarePlanReSignNotifications(response?.resultData));
    yield put(loaderAction(false));
  }
  catch (e) {
    yield put(loaderAction(false));
    console.error(e);
  }
}


